import { ArrowUpRight } from "lucide-react";
import { Reveal, ChapterTag } from "@/components/Reveal";
import { scrollToId } from "@/constants/site";

const JOURNEYS = [
  {
    name: "Kashmir Escape",
    note: "Shikara mornings on Dal Lake, pine valleys and slow mountain evenings.",
    img: "https://images.pexels.com/photos/6730641/pexels-photo-6730641.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  },
  {
    name: "Goa Getaway",
    note: "Golden beaches, quiet cafés and unhurried days by the Arabian Sea.",
    img: "https://images.unsplash.com/photo-1512343879784-a960bf40e7f2?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Kerala Retreat",
    note: "Backwater houseboats, misty tea gardens and coastal calm.",
    img: "https://images.unsplash.com/photo-1602216056096-3b40cc0c9944?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
  {
    name: "Udaipur Heritage Escape",
    note: "Lake palaces, old-city lanes and sunsets over Lake Pichola.",
    img: "https://images.unsplash.com/photo-1599661046827-dacff0c0f09a?crop=entropy&cs=srgb&fm=jpg&q=85&w=940",
  },
];

export const Inspiration = () => (
  <section data-testid="inspiration-section" className="bg-obsidian px-5 py-20 sm:px-8 sm:py-28 lg:px-16 lg:py-36">
    <div className="mx-auto max-w-7xl">
      <Reveal>
        <ChapterTag index="07" label="Travel Inspiration" />
      </Reveal>
      <div className="mt-10 flex flex-col justify-between gap-6 lg:flex-row lg:items-end">
        <Reveal delay={0.1}>
          <h2 className="font-serif text-4xl font-light leading-tight tracking-tight text-zinc-50 sm:text-5xl">
            Travel <span className="italic text-gold-gradient">Inspiration</span>
          </h2>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="max-w-sm text-sm font-light leading-relaxed text-zinc-400">
            Example journeys to spark ideas — every journey we plan is built from scratch around you.
          </p>
        </Reveal>
      </div>
      <div className="mt-14 grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-4">
        {JOURNEYS.map((j, i) => (
          <Reveal key={j.name} delay={0.08 + i * 0.1}>
            <button
              data-testid={`inspiration-card-${i}`}
              onClick={() => scrollToId("plan")}
              className="group w-full rounded-sm border border-white/10 bg-white/[0.03] text-left transition-all duration-500 hover:-translate-y-2 hover:border-gold/50 hover:shadow-2xl"
            >
              <div className="relative overflow-hidden">
                <img src={j.img} alt={j.name} className="aspect-[16/10] w-full object-cover transition-transform duration-[1.4s] ease-out group-hover:scale-108" />
                <span className="absolute left-3 top-3 rounded-full bg-[#0C0D0F]/80 px-3 py-1 text-[9px] font-mono uppercase tracking-[0.2em] text-gold backdrop-blur-sm">
                  Example Journey
                </span>
              </div>
              <div className="p-6">
                <div className="flex items-center justify-between">
                  <h3 className="font-serif text-xl font-normal text-zinc-100">{j.name}</h3>
                  <ArrowUpRight size={16} className="text-zinc-500 transition-all duration-300 group-hover:-translate-y-0.5 group-hover:translate-x-0.5 group-hover:text-gold" />
                </div>
                <p className="mt-3 text-sm font-light leading-relaxed text-zinc-400">{j.note}</p>
              </div>
            </button>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
